import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import * as Sentry from "@sentry/angular";

Sentry.init({
    dsn: "https://328fa7b1a33f0454c03f3be382cbc99e@o4506385370775552.ingest.us.sentry.io/4509719152951296",
    integrations: [
        Sentry.feedbackIntegration({
          // Additional SDK configuration goes in here, for example:
          colorScheme: "system",
          enableScreenshot: true,
          showBranding: false,
          autoInject: false,
               themeLight: {
        submitBackground: 'var(--primary-color)' // Example: using a PrimeNG variable
      },
      themeDark: {
        submitBackground: 'var(--primary-color)'
      }
        }),
        Sentry.replayIntegration()
      ],
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0 
  });

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
